// extracted by mini-css-extract-plugin
export default {"url":"\"https://fonts.googleapis.com/css?family=Raleway\""};